<template>
  <!-- Standalone header for the content pages, which don't have the
       generator's fixed left rail to hang branding off. Sticky unless the page
       pins the promo ribbon above it: the two would otherwise stack into a band
       too deep for a phone. -->
  <header class="top-0 z-40 border-b border-gray-900 bg-gray-950/90 backdrop-blur" :class="{ sticky }">
    <PageContainer as="nav" class="flex items-center justify-between gap-4 py-4" aria-label="Global">
      <NuxtLink to="/" class="shrink-0" @click="trackNav('logo')">
        <img :src="logo" width="170" height="26" alt="Colorize" class="w-[140px] sm:w-[170px]" />
      </NuxtLink>
      <div class="flex items-center gap-4 sm:gap-6">
        <TextLink href="/" class="hidden text-sm leading-6 sm:block" @click="trackNav('generator')">
          Generate a live palette
        </TextLink>
        <!-- The API key is the default action because it's what every content
             page is selling. A page with a call-to-action of its own overrides
             it rather than sitting under a second, competing button — see
             pages/browser-extension.vue. -->
        <slot name="action">
          <BaseButton :href="apiUrl('nav', route.path)" @click="trackNav('api')">
            Get an API Key
          </BaseButton>
        </slot>
      </div>
    </PageContainer>
  </header>
</template>

<script setup>
import { trackEvent } from '~/composables/analytics'
import BaseButton from '~/components/atoms/BaseButton.vue'
import PageContainer from '~/components/atoms/PageContainer.vue'
import TextLink from '~/components/atoms/TextLink.vue'
import logo from '~/assets/img/colorize_design_logo.svg'
import { apiUrl } from '~/utils/site'

defineProps({
  sticky: { type: Boolean, default: true },
})

// The nav is identical on the hub and on every brand page, so the target is in
// the event name and the page it was clicked from rides along as a parameter —
// and, on the outbound API link, in the URL so Prefetch sees it too.
const route = useRoute()

const trackNav = (target) => {
  try {
    trackEvent(`Nav Clicked (${target})`, { page: route.path })
  } catch {}
}
</script>
